import Swiper from 'swiper/js/swiper';

jQuery(function() {

  if ($('.info-slider').length > 0) {
    let spaceBetween = 10,
      slidesOffsetAfter = 10;
    if (window.innerWidth > 576) { //$screen-sm-min
      spaceBetween = 20;
      slidesOffsetAfter = 20;
    }
    new Swiper('.info-slider-container', {
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: spaceBetween,
      effect: 'slide',
      slidesOffsetAfter: slidesOffsetAfter,
      freeMode: true,
      freeModeSticky: true,
      navigation: {
        nextEl: '.info-slider-button-next',
        prevEl: '.info-slider-button-prev',
      },
    });
  }

});
